import { Box, FormGroup, Grid, IconButton, Modal, Typography } from "@mui/material";
import Crossicon from "../../Icon/Crossicon";
import { apiErrorMessage } from "../../helper/apiError";
import { fontSize } from "../theme/fontSize";
import { fontWeight } from "../theme/fontWeight";
import { FontFamily } from "../theme/fontFamily";
import { ThemeColor } from "../theme/color";
import moment from "moment";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import LeftSideArrow from "../../Icon/LeftSideArrow";
import { useEffect, useState } from "react";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import {
  GetStudentAction,
  GetStudentNotesByIdAction,
  GetStudentReminderByIdAction,
} from "../../Redux/action/ApplicationAction";
import {
  AddStudentNotesService,
  AddStudentTransferService,
  DeleteStudentNotesService,
  DeleteStudentReminderService,
} from "../../Redux/service/Application";
import ConfirmationModal from "../Modal/ConfirmationModal/ConfirmationModal";
import OutlinedInputField from "../inputfiled/OutlinedInput";
import CustomButton from "../button/button";
import { Form, Formik } from "formik";
import CustomSelect from "../select field/OutlinedSelectField";
import Agentlist from "../../page/Setting/Agentlist.page";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "85%", md: "550px" },
  maxHeight: "80vh",
  bgcolor: "#FFFFFF",
  borderRadius: "16px",
  boxShadow: "0 20px 50px rgba(0, 0, 0, 0.15)",
  border: "none",
  outline: "none",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

export const StudentTransferModal = ({
  TransferModal,
  handleClose,
  stdId,
  Agentlist,
  Studentlist,
}) => {
  const dispatch = useDispatch();

  const validationSchema = Yup.object({
    newAgent: Yup.string().required("Counselor is required to transfer!"),
  });

  return (
    <>
      <Modal
        open={TransferModal}
        onClose={() => handleClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 3,
              py: 2,
              bgcolor: ThemeColor.PURPLE,
              color: "#FFFFFF",
            }}
          >
            <Typography
              fontFamily={FontFamily.Poppins}
              fontWeight={fontWeight.W600}
              fontSize={fontSize.h3.medium}
              color="#FFFFFF"
            >
              Transfer to Other Counselor
            </Typography>
            <IconButton
              onClick={() => handleClose()}
              size="small"
              sx={{
                color: "#FFFFFF",
                bgcolor: "rgba(255, 255, 255, 0.15)",
                "&:hover": { bgcolor: "rgba(255, 255, 255, 0.3)" },
              }}
            >
              <Crossicon width={"16"} height={"16"} fill="#FFF" />
            </IconButton>
          </Box>
          <Box sx={{ flex: 1, overflowY: "auto", p: 3 }}>
          <Formik
            initialValues={{
              newAgent: "",
            }}
            validationSchema={validationSchema}
            onSubmit={async (values, { resetForm }) => {
              //("Form data:", values, stdId);
              //  console.log(Studentlist);

              if (Studentlist?.length > 0) {
                values["studentIds"] = Studentlist
                await AddStudentTransferService(values)
                  .then((res) => {
                    if (res.status === 200) {
                      // //(res);
                      dispatch(GetStudentAction());
                      dispatch(showSnackbar(res?.data.message, "success"));
                      handleClose()

                      resetForm();
                    }
                  })
                  .catch((e) => {
                    dispatch(showSnackbar(apiErrorMessage(e), "error"));
                  });
              } else {
                dispatch(showSnackbar("Select Atleast one student!", "error"));
              }
            }}
          >
            {({
              values,
              errors,
              handleBlur,
              handleChange,
              touched,
              handleSubmit,
              setFieldValue,
            }) => (
              <Form className="d-flex justify-content-center">
                <Box
                  className="addcatalog-container"
                  sx={{
                    width: { sm: "100%", xs: "100%", md: "100%", lg: "100%" },
                  }}
                >
                  <FormGroup style={{}} className="mt-3">
                    <div className="">
                      <CustomSelect
                        value={values?.newAgent}
                        name={"Agent"}
                        multiple={false}
                        option={Agentlist}
                        onBlur={handleBlur}
                        onChange={(e) =>
                          setFieldValue("newAgent", e.target.value)
                        }
                        fullWidth={true}
                        // disabled={RoleTypeAgent && true}
                        label={"Counselor Name"}
                        helperText={
                          <Typography
                            align="left"
                            // className="px-4"
                            color={ThemeColor.RED}
                            fontSize={fontSize.h4.medium}
                            fontFamily={FontFamily.Lato}
                            fontWeight={fontWeight.W500}
                          >
                            {errors.newAgent}
                          </Typography>
                        }
                      />
                    </div>
                  </FormGroup>

                  <Box
                    sx={{
                      flexDirection: {
                        lg: "row",
                        md: "row",
                        sm: "column",
                        xs: "column",
                      },
                    }}
                    className="d-flex justify-content-center align-items-center h-100 w-100 mt-3"
                  >
                    {" "}
                    <CustomButton
                      variant="contained"
                      type="submit"
                      backgroundColor={ThemeColor.PURPLE}
                      color={ThemeColor.WHITE}
                    >
                      Transfer
                    </CustomButton>
                    <Box
                      className="px-2"
                      sx={{
                        paddingTop: {
                          lg: "0px",
                          md: "0px",
                          sm: "5px",
                          xs: "5px",
                        },
                      }}
                    >
                      <CustomButton
                        variant="contained"
                        // type="submit"
                        backgroundColor={ThemeColor.RED}
                        color={ThemeColor.WHITE}
                        //   padding={"0px"}
                        onClick={() => {
                          //   resetForm();
                          handleClose();
                        }}
                      >
                        Cancel
                      </CustomButton>
                    </Box>
                  </Box>
                </Box>
              </Form>
            )}
          </Formik>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
